import { render, staticRenderFns } from "./WalletContents.vue?vue&type=template&id=2c49dca4&"
import script from "./WalletContents.vue?vue&type=script&lang=js&"
export * from "./WalletContents.vue?vue&type=script&lang=js&"
import style0 from "./WalletContents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports